import React, { useState } from 'react';
import { Cloud, Lock, Save, Link as LinkIcon, Info } from 'lucide-react';
import axios from 'axios';
import toast from 'react-hot-toast';

const CloudConfig = () => {
    const [config, setConfig] = useState({
        provider: 'google drive', // dropbox, onedrive
        remote_name: 'remote_drive',
        client_id: '',
        client_secret: '',
        token: '' // الـ Access Token لو موجود
    });

    const handleSaveConfig = async () => {
        const loadId = toast.loading("Saving Cloud Configuration...");
        try {
            // هنبعت البيانات دي للباكيند عشان يحدث ملف rclone.conf
            await axios.post('/api/admin/backup/config', config);
            toast.success("Cloud Linked Successfully!", { id: loadId });
        } catch (err) {
            toast.error("Failed to link cloud: " + err.message, { id: loadId });
        }
    };

    return (
        <div className="p-8 bg-gray-50 min-h-screen font-sans uppercase text-[11px] font-bold">
            <div className="bg-white rounded-lg shadow-xl p-8 max-w-2xl mx-auto border-t-4 border-orange-500">
                <h2 className="flex items-center gap-3 text-lg text-blue-900 font-black mb-8 border-b pb-4">
                    <Cloud size={24} className="text-blue-500"/> Cloud Integration Settings
                </h2>

                <div className="space-y-6">
                    {/* اختيار المزود */}
                    <div className="flex flex-col gap-2">
                        <label className="text-gray-400">Cloud Storage Provider</label>
                        <select 
                            className="p-3 border rounded bg-gray-50 text-blue-900 outline-none"
                            value={config.provider}
                            onChange={(e) => setConfig({...config, provider: e.target.value})}
                        >
                            <option value="drive">Google Drive</option>
                            <option value="dropbox">Dropbox</option>
                            <option value="onedrive">Microsoft OneDrive</option>
                        </select>
                    </div>

                    <div className="grid grid-cols-2 gap-4">
                        <div className="flex flex-col gap-2">
                            <label className="text-gray-400">Client ID</label>
                            <input 
                                className="p-3 border rounded outline-none focus:border-blue-500 font-mono text-[10px]"
                                placeholder="Paste Client ID here..."
                                value={config.client_id}
                                onChange={(e) => setConfig({...config, client_id: e.target.value})}
                            />
                        </div>
                        <div className="flex flex-col gap-2">
                            <label className="text-gray-400">Client Secret</label>
                            <input 
                                type="password"
                                className="p-3 border rounded outline-none focus:border-blue-500 font-mono text-[10px]"
                                placeholder="Paste Client Secret here..."
                                value={config.client_secret}
                                onChange={(e) => setConfig({...config, client_secret: e.target.value})}
                            />
                        </div>
                    </div>

                    <div className="p-4 bg-yellow-50 rounded border border-yellow-100 flex gap-3 text-yellow-800">
                        <Info size={20} className="shrink-0"/>
                        <p className="normal-case font-medium leading-relaxed">
                            To get these credentials, you need to create an App in your Cloud Provider's developer console. 
                            The redirect URI should be set to your server's callback URL.
                        </p>
                    </div>

                    <button 
                        onClick={handleSaveConfig}
                        className="w-full py-4 bg-blue-900 text-white rounded font-black flex items-center justify-center gap-2 hover:bg-black transition-all shadow-lg"
                    >
                        <Save size={16}/> SAVE & LINK CLOUD STORAGE
                    </button>
                </div>
            </div>
        </div>
    );
};

export default CloudConfig;